import(/* webpackMode: "eager" */ "/codebuild/output/src2645928123/src/midapos/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2645928123/src/midapos/src/app/components/AmplifyProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2645928123/src/midapos/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2645928123/src/midapos/src/app/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2645928123/src/midapos/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/codebuild/output/src2645928123/src/midapos/src/AuthContext.tsx");
